import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CSRF_COOKIE_NAME = 'csrf_token';

// Helper to get cookie value
function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

export const orderApi = axios.create({ 
  baseURL: API,
  withCredentials: true, // Include httpOnly cookies in requests
});

orderApi.interceptors.request.use((config) => {
  // Include CSRF token for state-changing requests
  const method = (config.method || '').toUpperCase();
  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    const csrfToken = getCookie(CSRF_COOKIE_NAME);
    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken;
    }
  }
  
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return 'Algo salió mal. Inténtalo de nuevo.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export { API };
